// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".editor{width:100%;margin:0 auto;position:relative;z-index:0}.text,.toolbar{border:1px solid #ccc}.text{height:250px;max-height:350px}.w-e-toolbar .w-e-menu i{font-size:12px!important}", ""]);
// Exports
module.exports = exports;
